import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name"]
const _hoisted_2 = { tabindex: "0" }
const _hoisted_3 = { class: "accordion__summary-meta" }

import ChevronDown from '@src/components/shared/icons/ChevronDown.vue';

interface Props {
	name?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AccordionItem',
  props: {
    name: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("details", {
    name: __props.name ? __props.name : null
  }, [
    _createElementVNode("summary", _hoisted_2, [
      _renderSlot(_ctx.$slots, "title"),
      _createElementVNode("span", _hoisted_3, [
        _renderSlot(_ctx.$slots, "meta"),
        _createVNode(ChevronDown)
      ])
    ]),
    _createElementVNode("div", null, [
      _renderSlot(_ctx.$slots, "content")
    ])
  ], 8, _hoisted_1))
}
}

})